import script from "./BankDetailsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./BankDetailsEdit.vue?vue&type=script&setup=true&lang=js"

import "./BankDetailsEdit.vue?vue&type=style&index=0&id=e4005f8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4005f8e"]])

export default __exports__